import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { FC } from "react";
import LinkSignUpForm from "./LinkSignUpForm";
import OauthButton from "./OauthButton";
import OauthHeader from "./OauthHeader";

export interface IFormActivationState {
  activationKey: string,
}

const FormActivation: FC<{
  state: IFormActivationState,
  stateErr: Partial<IFormActivationState>,
  setState: (key: keyof IFormActivationState, value: string) => unknown,
  onHandler: () => unknown,
}> = ({
  state,
  stateErr,
  setState,
  onHandler,
}) => (
  <>
    <OauthHeader>
      Mail activation
    </OauthHeader>
    
    <Box sx={{ mt: 1 }}>
      <TextField
        margin="normal"
        required
        fullWidth
        id="activationKey"
        label="Activation Key"
        value={state.activationKey}
        onChange={(e) => setState('activationKey', e?.target?.value)}
        error={!!stateErr?.activationKey}
        helperText={stateErr?.activationKey ?? ''}
        autoFocus
      />
      <Grid container justifyContent='flex-end'>        
        <LinkSignUpForm />
      </Grid>
      <OauthButton onClick={onHandler}>
        Activate Email
      </OauthButton>
    </Box>
  </>
);

export default FormActivation;
